import { render, staticRenderFns } from "./distribution-panel-form.component.vue?vue&type=template&id=84756248"
import script from "./distribution-panel-form.component.ts?vue&type=script&lang=ts&external"
export * from "./distribution-panel-form.component.ts?vue&type=script&lang=ts&external"
import style0 from "./distribution-panel-form.component.vue?vue&type=style&index=0&id=84756248&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84756248')) {
      api.createRecord('84756248', component.options)
    } else {
      api.reload('84756248', component.options)
    }
    module.hot.accept("./distribution-panel-form.component.vue?vue&type=template&id=84756248", function () {
      api.rerender('84756248', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/distribution-panel-form/distribution-panel-form.component.vue"
export default component.exports